import { toast } from '@savgroup-front-common/core/atoms/Toast';
import {
  APP_STATUS_IMPACT,
  AppIncident,
  AppScheduledMaintenance,
} from '@savgroup-front-common/types';

import {
  CompletedScheduledMaintenance,
  InProgressScheduledMaintenance,
  NewScheduledMaintenance,
  RescheduledMaintenance,
  ToastIncident,
} from '../ToastStatus';

export const displayUnresolvedIncident = (incident: AppIncident) => {
  if (
    incident.impact === APP_STATUS_IMPACT.CRITICAL ||
    incident.impact === APP_STATUS_IMPACT.MAJOR
  ) {
    toast.error(<ToastIncident incident={incident} />, {
      autoClose: false,
      title: incident.name,
    });
  } else if (
    incident.impact === APP_STATUS_IMPACT.MINOR ||
    incident.impact === APP_STATUS_IMPACT.NONE
  ) {
    toast.warn(<ToastIncident incident={incident} />, {
      autoClose: false,
      title: incident.name,
    });
  }
};

export const displayResolvedIncident = (incident: AppIncident) => {
  toast.success(<ToastIncident incident={incident} />, {
    autoClose: false,
    title: incident.name,
  });
};

export const displayInProgressScheduledMaintenance = (
  scheduledMaintenance: AppScheduledMaintenance,
) => {
  toast.info(
    <InProgressScheduledMaintenance
      scheduledMaintenance={scheduledMaintenance}
    />,
    { autoClose: false, title: scheduledMaintenance.name },
  );
};

export const displayCompletedScheduledMaintenance = (
  scheduledMaintenance: AppScheduledMaintenance,
) => {
  toast.success(
    <CompletedScheduledMaintenance
      scheduledMaintenance={scheduledMaintenance}
    />,
    { autoClose: false, title: scheduledMaintenance.name },
  );
};

export const displayRescheduledMaintenance = (
  scheduledMaintenance: AppScheduledMaintenance,
) => {
  toast.info(
    <RescheduledMaintenance scheduledMaintenance={scheduledMaintenance} />,
    { autoClose: false, title: scheduledMaintenance.name },
  );
};

export const displayNewScheduledMaintenance = (
  scheduledMaintenance: AppScheduledMaintenance,
) => {
  toast.info(
    <NewScheduledMaintenance scheduledMaintenance={scheduledMaintenance} />,
    { autoClose: false, title: scheduledMaintenance.name },
  );
};
